import { filter, pick } from "lodash";
import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import { connect } from "react-redux";

import ModalHeading from "../../components/modal/ModalHeading";
import ModalTabView from "../../components/modal/ModalTabView";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import Dimensions from "../../constants/styles/dimensions";
import { preferencesOperations, preferencesSelectors } from "../../modules/preferences";
import { uiStateOperations } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { trackEvent } from "../../utils/trackAnalytics";
import userAgent from "../../utils/userAgent";
import SmartErrorBoundary from "../smartErrorBoundary";
import PreferencesAppearanceTab from "./PreferencesAppearanceTab";
import PreferencesSyncingTab from "./PreferencesSyncingTab";
import PreferencesTemplatesTab from "./PreferencesTemplatesTab";

// import PreferencesUpdatesTab from "./PreferencesUpdatesTab";

class PreferencesModal extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.PREFERENCES_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.PREFERENCES_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  tabViews() {
    const isWindowsApp = userAgent.isWindowsApp();
    return filter(
      [
        {
          icon: "settingsColors",
          label: "Appearance",
          view: (
            <PreferencesAppearanceTab
              {...pick(this.props, [
                "dateOrder",
                "thousandsSeparator",
                "skin",
                "onDateOrderChange",
                "onThousandsSeparatorChange",
                "onSkinChange"
              ])}
            />
          )
        },
        //#!if readonly !== true
        // {
        //   icon: "folder",
        //   label: "Auto Backup",
        //   view: (
        //     <PreferencesBackupTab
        //       {...pick(this.props, [
        //         "autoBackup",
        //         "autoBackupCopies",
        //         "autoBackupLocation",
        //         "onAutoBackupChange",
        //         "onAutoBackupCopiesChange",
        //         "onAutoBackupLocationChange"
        //       ])}
        //     />
        //   )
        // },
        //#!endif
        // {
        //   icon: "settingsDownload",
        //   label: "Updates",
        //   view: (
        //     <PreferencesUpdatesTab
        //       {...pick(this.props, [
        //         "autoCheckUpdates",
        //         "autoDownloadUpdates",
        //         "onAutoCheckUpdatesChange",
        //         "onAutoDownloadUpdatesChange"
        //       ])}
        //     />
        //   )
        // },
        {
          icon: "settingsTypes",
          label: "Custom Templates",
          view: <PreferencesTemplatesTab />
        },
        isWindowsApp
          ? {
            icon: "settingsSync",
            label: "Syncing",
            view: (
              <PreferencesSyncingTab {...pick(this.props, ["autoCloseScrivener", "onAutoCloseScrivenerChange"])} />
            )
          }
          : null
      ],
      v => v
    );
  }

  render() {
    let modalHeading = null;
    let modalFooter = null;
    let fixedHeight = null;

    // #!if iOS === true
// modalHeading = (
// <ModalHeading
// title="Aeon Timeline Preferences"
// showDone={true}
// doneText={"Close"}
// onDoneClick={this.props.onCloseClick}
// />
// );
// fixedHeight = Dimensions.MODAL_MAX_HEIGHT;
    // #!else
    modalHeading = (
      <ModalHeading title="Aeon Timeline Preferences" showCancel={true} onCancelClick={this.props.onCloseClick} />
    );
    // #!endif

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={fixedHeight}>
        <SmartErrorBoundary>
          <ModalTabView tabs={this.tabViews()} />
        </SmartErrorBoundary>
      </ModalView>
    );
  }
}

PreferencesModal.propTypes = {
  dateOrder: PropTypes.string.isRequired,
  thousandsSeparator: PropTypes.string.isRequired,
  skin: PropTypes.string.isRequired,
  autoBackupEnabled: PropTypes.bool.isRequired,
  autoBackupLocation: PropTypes.string,
  autoCheckUpdates: PropTypes.bool.isRequired,
  autoDownloadUpdates: PropTypes.bool.isRequired,

  autoCloseScrivener: PropTypes.bool.isRequired,

  onCloseClick: PropTypes.func.isRequired,
  onDateOrderChange: PropTypes.func.isRequired,
  onThousandsSeparatorChange: PropTypes.func.isRequired,
  onSkinChange: PropTypes.func.isRequired,
  onAutoBackupChange: PropTypes.func.isRequired,
  // onAutoBackupCopiesChange: PropTypes.func.isRequired,
  onAutoBackupLocationChange: PropTypes.func.isRequired,
  onAutoCheckUpdatesChange: PropTypes.func.isRequired,
  onAutoDownloadUpdatesChange: PropTypes.func.isRequired,
  onAutoCloseScrivenerChange: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    dateOrder: preferencesSelectors.getDateOrder(state.present),
    thousandsSeparator: preferencesSelectors.getThousandsSeparator(state.present),
    skin: preferencesSelectors.getSkin(state.present),
    autoBackupEnabled: preferencesSelectors.getAutoBackupEnabled(state.present),
    autoBackupLocation: preferencesSelectors.getAutoBackupLocation(state.present),
    autoCheckUpdates: preferencesSelectors.getAutoCheckUpdates(state.present),
    autoDownloadUpdates: preferencesSelectors.getAutoDownloadUpdates(state.present),
    autoCloseScrivener: preferencesSelectors.getAutoCloseScrivener(state.present)
  };
};

const readonlyActions = {
  onCloseClick: uiStateOperations.hidePreferencesModal,
  onDateOrderChange: preferencesOperations.setDateOrder,
  onThousandsSeparatorChange: preferencesOperations.setThousandsSeparator,
  onSkinChange: (skin, oldSkin) => {
    trackEvent("setPreferences", "setSkin", skin);
    trackEvent("setPreferences", "oldSkin", oldSkin);
    return preferencesOperations.setSkin(skin);
  },
  onAutoBackupChange: preferencesOperations.setAutoBackup,
  // onAutoBackupCopiesChange: preferencesOperations.setAutoBackupCopies,
  onAutoBackupLocationChange: preferencesOperations.setAutoBackupLocation,
  onAutoCheckUpdatesChange: preferencesOperations.setAutoCheckUpdates,
  onAutoDownloadUpdatesChange: preferencesOperations.setAutoDownloadUpdates,
  onAutoCloseScrivenerChange: preferencesOperations.setAutoCloseScrivener
};

const editingActions = {};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesModal);
